import { sendError } from 'next/dist/server/api-utils'
import JobCategoriesFixture from '../static-data/JobCategoriesFixture'
// import { JobCategorySerializeType, NestedCategoryType } from '../type/Common'
import { useTranslation } from './useTranslation'

export const useJobCategories = () => {
  const { currentLanguage } = useTranslation()
  const job_categories = JobCategoriesFixture.data.map((ser) => ({
    ...ser.attributes,
    subs: [
      {
        id: ser.attributes.id,
        name: ser.attributes.name,
        name_vn: ser.attributes.name_vn,
        sub_label: currentLanguage === 'en' ? 'All - ' : 'Tất cả - '
      },
      ...ser.attributes.subs.data.map((ser2) => ({
        ...ser2.attributes
      }))
    ]
  }))

  const findIndexOthers = job_categories.findIndex((session) => session.name.toLocaleLowerCase() === 'others')
  if (findIndexOthers !== -1) {
    const filterRemoveOthers = job_categories.filter((session) => session.name.toLocaleLowerCase() !== 'others')
    filterRemoveOthers.push(job_categories[findIndexOthers])

    const new_job_categories = []
    filterRemoveOthers.forEach((ser) => {
      const sub_categories = ser.subs.map((item) => ({
        name: currentLanguage === 'en' ? item.name : item.name_vn,
        label: 'child',
        ...item
      }))
      new_job_categories.push({
        id: ser.id,
        name: ser.name,
        name_vn: ser.name_vn,
        label: 'parent',
        subs: sub_categories,
        sub_label: currentLanguage === 'en' ? 'All' : 'Tất cả'
      })
      new_job_categories.push(...sub_categories)
    })

    return { job_categories: filterRemoveOthers, new_job_categories }
  }
  return { job_categories: [], new_job_categories: [] }
}
